namespace TotalPoll {
    import MediaUploadService = TotalCore.Common.Providers.MediaUploadService;
    import UniqueIdService = TotalCore.Common.Providers.UniqueIdService;
    import Component = TotalCore.Common.Component;
    import shuffle = TotalCore.Common.shuffle;

    @Component('components.totalpoll', {
        templateUrl: 'choices-component-template',
        bindings: {
            items: '=',
        }
    })
    class ChoicesComponent {
        public bulkContent = '';
        public bulkInput = false;
        public droppable = false;
        public filterList = false;
        public items: any[];
        public media;
        public mediaUploader;
        public overrideVotes = false;
        public types = {
            text: true,
            image: true,
            video: true,
            audio: true,
            html: true,
        };

        constructor(private MediaUploadService: MediaUploadService, private $scope, private $element, private UniqueIdService: UniqueIdService) {
        }

        $onInit() {
            setTimeout(() => this.handleDrop(), 3000);
        }

        collapseChoices() {
            this.setCollapsedForAll(true);
        }

        confirmOverride($event) {
            if (this.overrideVotes) {
                return;
            }

            if (confirm(window['TotalPollI18n']['ATTENTION! Overriding votes is not reversible. Are you sure you want to override votes?'])) {
                this.overrideVotes = true;
            } else {
                $event.preventDefault();
                $event.target.blur();
            }
        }

        // CHOICES
        deleteChoice(choiceIndex, confirmed = false) {
            if (confirmed || confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items.splice(choiceIndex, 1);
            }
        }

        deleteChoices() {
            if (confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items = [];
            }
        }

        expandChoices() {
            this.setCollapsedForAll(false);
        }

        filterByType() {
            return (choice) => {
                return this.isTypeActive(choice.type);
            };
        }

        // INSERTION
        insertBulkChoices() {
            //@PRO
            let choices = this.bulkContent.split("\n");
            this.collapseChoices();
            choices.forEach((choice) => {
                if (choice.trim() !== '') {
                    this.insertChoice({type: 'text', label: choice});
                }
            });

            this.bulkContent = '';
            this.toggleBulkInput();
            //@END-PRO
        }

        insertChoice(args) {
            this.collapseChoices();

            args = angular.extend({}, {
                uid: this.UniqueIdService.generate(),
                type: 'text',
                label: `Choice #${this.items.length + 1}`,
                votes: 0,
                votesOverride: 0,
                collapsed: false,
                visibility: true
            }, args);
            this.items.push(args);
            this.types[args.type] = true;
        }

        isTypeActive(type) {
            return Boolean(this.types[type]);
        }

        randomVotes() {
            if (confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items.forEach(function (item) {
                    item.votesOverride = Math.floor(Math.random() * (100 - 1 + 1)) + 1;
                });
            }
        }

        // VOTES
        resetVotes() {
            if (confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items.forEach(function (item) {
                    item.votesOverride = 0;
                });
            }
        }

        // COLLAPSING
        setCollapsedForAll(collapsed) {
            this.items.forEach(function (item) {
                item.collapsed = collapsed;
            });
        }

        shuffleChoices() {
            if (confirm(window['TotalPollI18n']['Are you sure?'])) {
                this.items = shuffle(this.items);
            }
        }

        // TOGGLE
        toggleBulkInput() {
            //@PRO
            this.bulkInput = !this.bulkInput;
            //@END-PRO
        }

        toggleFilterList() {
            //@PRO
            this.filterList = !this.filterList;
            //@END-PRO
        }

        toggleType(type) {
            this.types[type] = !this.isTypeActive(type);
        }

        private handleDrop() {
            let cancelDefault = function (event) {
                event.preventDefault();
                event.stopPropagation();
            };

            let setDroppable = (droppable) => {
                this.$scope.$applyAsync(() => this.droppable = droppable);
            };

            this.media = this.MediaUploadService.customFrame({
                frame: 'post',
                state: 'insert',
                multiple: true
            });

            this.media.open().on('uploader:ready', () => this.mediaUploader = this.media.uploader.uploader.uploader).close();

            this.$element.on('drag', (event) => cancelDefault(event));

            this.$element.on('dragleave', (event) => cancelDefault(event) && setDroppable(false));

            this.$element.on('dragover', (event) => {
                cancelDefault(event);
                event.originalEvent.dataTransfer.dropEffect = 'copy';

                if (event.originalEvent.dataTransfer.types.indexOf('application/x-dnd') === -1) {
                    setDroppable(true);
                }
            });

            this.$element.on('drop', (event) => {
                cancelDefault(event);

                angular.forEach(event.originalEvent.dataTransfer.items, (item) => {
                    if (item.type === 'text/plain') {
                        item.getAsString((content) => {
                            let choices = content.trim().split(/\r|\n/).filter(Boolean);
                            angular.forEach(choices, (choice) => this.insertChoice({type: 'text', label: choice.trim()}));
                        });
                    } else if (item.type === 'text/html') {
                        //@PRO
                        var reader = new FileReader();
                        try {
                            reader.addEventListener('load', (event) => {
                                if (event.target['result']) {
                                    this.insertChoice({type: 'html', html: event.target['result']});
                                }
                            }, false);
                            reader.readAsText(item.getAsFile() || new Blob());
                        } catch (exception) {
                            alert(`Something went wrong (${exception.toString()}). Retry?`);
                        }
                        //@END-PRO
                    } else if (['image', 'video', 'audio'].indexOf(item.type.split('/').shift()) != -1 && item.kind === 'file') {
                        //@PRO
                        // this.MediaUploadService.frame(item.type.split('/').shift());
                        this.media.open();
                        this.mediaUploader.addFile([item.getAsFile()]);
                        //@END-PRO
                    }
                });

                setDroppable(false);
                this.collapseChoices();

                return false;
            });

            //@PRO
            this.media.on('insert', (selection) => {
                angular.forEach(selection.toJSON(), (file) => {
                    if (['image', 'video', 'audio'].indexOf(file.type) == -1) {
                        return;
                    }
                    let choice = {type: file.type, label: file.title || file.label};
                    choice[file.type] = {sizes: file.sizes, full: file.url, thumbnail: file.sizes && file.sizes.thumbnail ? file.sizes.thumbnail.url : file.url};
                    this.insertChoice(choice);
                });
                setDroppable(false);
            });
            //@END-PRO
        }
    }
}
